<script>
/**
 * 排出事業者データ補完
 * 排出事業者新規登録画面
 */
import {mapActions, mapGetters, mapState} from "vuex";
import PrefectureList from "../../../..//mixins/PrefectureList";
import Confirm from "../../../..//components/Confirm.vue";
import ZipCodeSearch from "../../../../components/ZipCodeSearch.vue";
import SearchZipModal from "../../../components/SearchZipModal.vue";

export default {
  name: "EmissionAddModal",
  components: {
    Confirm,
    ZipCodeSearch,
    SearchZipModal
  },
  mixins: [ PrefectureList ],
  props: {
    dialog: {
      type: Boolean,
      default: () => false
    },
    targetId: {
      type: Number,
      default: () => null
    },
    targetSelectableIds: {
      type: Array,
      default: () => [],
    },
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  data () {
    return {
      billingAddressDialog: false,
      emission: {
        id: null,
        name: null,
        subscriber_number: null,
        dxe_emission_id: null,
        dxe_emission_name: null,
        manifest_type: 'other_form',
        email_1: null,
        staff_1: null,
        email_2: null,
        staff_2: null,
        use_recycle: false,
        zip_code: null,
        prefecture_code: null,
        address_1: null,
        address_2: null,
        address_3: null,
        phone_number: null,
        dxe_emission_registered: false,
        billing_address_name: null,
        billing_address_id: null,
        memo: null,
        sort_priority: null,
      },
      withSelected: false,
      manifestTypes: [],
      dxeEmissionMessage: null,
      enableSearchZipModal: false,
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
    disabledSubscriberNumber: function() {
      return ((this.emission.id != null && this.emission.dxe_emission_registered) || (!["dxe_form"].includes(this.emission.manifest_type)))
    }
  },
  watch: {
    dialog (val) {
      Object.assign(this.$data.emission, this.$options.data().emission);
      this.$nextTick(() => this.$refs.EmissionFormValidator.reset());
      this.withSelected = false;
      this.dxeEmissionMessage = null;
      this.scrollToTop();
      if (val) {
        this.loadEmission();
      }
    },
  },
  methods: {
    ...mapActions("DriverTransferEmission", {
      fetchEmission: "show",
      createEmission: "create",
    }),
    ...mapActions('DriverMasterDxeEmission', {
      searchDxeEmission: 'show'
    }),
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    /**
     * 利用状況確認ボタン クリックイベント
     */
    searchDxeEmissionButtonClickEvent () {
      this.searchDxeEmission({subscriber_number: this.emission.subscriber_number}).then((content) => {
        if (content.exists) {
          this.emission.dxe_emission_id = content.id
          this.emission.dxe_emission_name = content.name
        }
        this.setMessage()
      })
    },
    manifestTypeChangeEvent () {
      if (['other_form', 'paper_form'].includes(this.emission.manifest_type)) {
        this.emission.dxe_emission_id = null;
        this.emission.dxe_emission_name = null;
        this.dxeEmissionMessage = null;
        this.emission.dxe_emission_registered = false;
      }
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit("closeCallback")
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let modalOption = {
        title: '確認',
        message: '登録・紐付けをします。よろしいですか？',
        options: {width: 320, isCancelButton: true}
      }
      this.$refs.EmissionFormValidator.validate().then((result) => {
        if (result) {
          this.$refs.confirm.open(modalOption).then((confirm) => {
            this.$refs.confirm.close()
            if (confirm) {
              this.register();
            }
          })
        }
      })
    },
    /**
     * 登録処理
     */
    register () {
      const params = {
        jwnet_manifest_id: this.targetId,
        searched_at: this.searchedAt,
        jwnet_manifest_ids: this.withSelected ? this.targetSelectableIds : [],
        ...this.emission
      }
      this.createEmission({params: params}).then(() => {
        this.$emit("registerCallback");
      });
    },
    /**
     * 郵便番号検索 コールバック
     * @param content
     */
    zipAddressCallback (content) {
      this.emission.prefecture_code = `${content.pref_code}`;
      this.emission.address_1 = `${content.locality}`;
      this.emission.address_2 = `${content.street}`;
    },
    loadEmission () {
      this.fetchEmission({ jwnet_manifest_id: this.targetId }).then((content) => {
        this.emission = content;
        this.manifestTypes = content.manifest_types;
      })
    },
    setMessage () {
      if (this.emission.dxe_emission_id) {
        this.dxeEmissionMessage = '利用可能です。JWNET加入者名：' + this.emission.dxe_emission_name
      } else {
        if (this.emission.subscriber_number) {
          this.dxeEmissionMessage = '利用できない加入者番号です。DXEにお問い合わせ下さい'
        }
      }
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('emissionAddBody');
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[0].scrollTop = 0;
    },
    closeModalCallback () {
      this.enableSearchZipModal = false;
    },
    /**
     * 郵便番号検索反映ボタン コールバック
     * @param address { Object }
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { number } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    searchZipReflectCallback (address) {
      this.emission.zip_code = address.zip_code
      this.emission.prefecture_code = `${address.prefecture_code}`
      this.emission.address_1 = address.city
      this.emission.address_2 = address.town
    },
    searchZipReflectZipCallback (zipCode) {
      this.emission.zip_code = zipCode;
    },
  }
}
</script>

<template>
  <div>
    <validation-observer
      ref="EmissionFormValidator"
    >
      <v-dialog
        :value="dialog"
        width="1300"
        scrollable
        @click:outside="closeButtonClickEvent"
        @close="closeButtonClickEvent"
        @keydown.esc="closeButtonClickEvent"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>
              排出事業者追加
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="closeButtonClickEvent"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-title
            class="primary--text"
          >
            排出事業者
          </v-card-title>
          <v-card-text
            class="emissionAddBody"
            style="height: 80vh;"
          >
            <v-container fluid>
              <v-row dense>
                <!-- コード -->
                <v-col
                  cols="12"
                  md="3"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    class="requiredMark"
                    name="事業者コード"
                    rules="required|alpha_num_only|max:10"
                  >
                    <v-text-field
                      v-model="emission.code"
                      :error-messages="errors"
                      dense
                      hide-details="auto"
                      label="事業者コード"
                      outlined
                      persistent-placeholder
                      placeholder="例）H001"
                    >
                      <template v-slot:label>
                        <span>事業者コード</span>
                        <span class="ml-1">
                          ({{ emission.code?.length || 0 }} / 10)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <!-- /コード -->
                 <v-col
                  cols="12"
                  md="7"
                >
                  最近使用したコード:&nbsp;<strong>{{ emission.recent_registered_codes }}</strong>
                </v-col>
              </v-row>

              <v-row dense>
                <!-- 会社名 -->
                <v-col
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    class="requiredMark"
                    name="会社名"
                    rules="required|max:60"
                  >
                    <v-text-field
                      v-model="emission.name"
                      :error-messages="errors"
                      dense
                      hide-details="auto"
                      label="会社名"
                      outlined
                      persistent-placeholder
                      placeholder="例）○○○○　株式会社"
                    >
                      <template v-slot:label>
                        <span>会社名</span>
                        <span class="ml-1">
                          ({{ emission.name?.length || 0 }} / 60)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <!-- 会社名 -->
              </v-row>

              <!-- マニフェスト区分 -->
              <v-row dense>
                <v-col
                  cols="12"
                  md="12"
                >
                  <h4 class="pt-0">
                    マニフェスト区分
                  </h4>
                  <v-radio-group
                    v-model="emission.manifest_type"
                    row
                    dense
                    hide-details="auto"
                    class="mt-0"
                    @change="manifestTypeChangeEvent"
                  >
                    <v-radio
                      v-for="n in manifestTypes"
                      :key="n.value"
                      :label="n.text"
                      :value="n.value"
                    />
                  </v-radio-group>
                </v-col>
                <!-- /マニフェスト区分 -->
              </v-row>
              <v-row dense>
                <v-col
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="加入者番号"
                    :class="emission.manifest_type === 'dxe_form' ? 'requiredMark' : ''"
                    :rules="{
                      required: (emission.manifest_type === 'dxe_form'),
                      alpha_num_only: true,
                      length: 7,
                    }"
                  >
                    <v-text-field
                      v-model="emission.subscriber_number"
                      :error-messages="errors"
                      dense
                      filled
                      hide-details="auto"
                      hint="JWNETと連携する場合は必須項目です"
                      label="加入者番号"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      placeholder="例）1234567"
                      readonly
                    >
                      <template v-slot:label>
                        <span>加入者番号</span>
                        <span class="ml-1">
                          ({{ emission.subscriber_number?.length || 0 }} / 7)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                      <template v-slot:append>
                        <v-btn
                          :disabled="disabledSubscriberNumber"
                          outlined
                          small
                          @click="searchDxeEmissionButtonClickEvent"
                        >
                          利用状況確認
                        </v-btn>
                      </template>
                    </v-text-field>
                  </validation-provider>
                  <template>
                    <p class="red--text text-left">
                      {{ dxeEmissionMessage }}
                    </p>
                  </template>
                  <v-text-field
                    v-if="false"
                    v-model="emission.dxe_emission_id"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- 郵便番号 -->
              <v-row dense>
                <v-col cols="12" md="5">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{zip_code: true, required: true, max:8 }"
                    class="requiredMark"
                    name="郵便番号"
                  >
                    <v-text-field
                      v-model="emission.zip_code"
                      :error-messages="errors"
                      dense
                      hide-details="auto"
                      hint="ハイフンを含めて入力してください"
                      label="郵便番号"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      placeholder="例）111-1111"
                      required
                    >
                      <template v-slot:label>
                        <span>郵便番号</span>
                        <span class="ml-1">
                          ({{ emission.zip_code?.length || 0 }} / 8)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                      <template v-slot:append-outer>
                        <zip-code-search
                          :zip-code="emission.zip_code"
                          @zipAddress="zipAddressCallback"
                        />
                        &nbsp;
                        <v-btn
                          outlined
                          small
                          @click="searchZipButtonClickEvent"
                        >
                          住所→郵便番号
                        </v-btn>
                      </template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /郵便番号 -->

              <!-- 都道府県／市区町村 -->
              <v-row dense>
                <v-col cols="12" md="3">
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="都道府県"
                    class="requiredMark"
                  >
                    <v-autocomplete
                      v-model="emission.prefecture_code"
                      :error-messages="errors"
                      :items="prefList"
                      dense
                      hide-details="auto"
                      item-text="text"
                      item-value="value"
                      label="都道府県"
                      outlined
                      persistent-placeholder
                      placeholder="例）東京都"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|full_width|max:20"
                    name="市区町村"
                    class="requiredMark"
                  >
                    <v-text-field
                      v-model="emission.address_1"
                      :error-messages="errors"
                      dense
                      label="市区町村"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      placeholder="例）中央区"
                      required
                    >
                      <template v-slot:label>
                        <span>市区町村</span>
                        <span class="ml-1">
                          ({{ emission.address_1?.length || 0 }} / 20)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /都道府県／市区町村 -->

              <!-- 町域 -->
              <v-row dense>
                <v-col cols="12" md="9">
                  <validation-provider
                    v-slot="{ errors }"
                    name="町域"
                    rules="full_width|max:40"
                  >
                    <v-text-field
                      v-model="emission.address_2"
                      :error-messages="errors"
                      dense
                      label="町域"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      placeholder="例）日本橋兜町"
                    >
                      <template v-slot:label>
                        <span>町域</span>
                        <span class="ml-1">
                          ({{ emission.address_2?.length || 0 }} / 40)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /町域 -->

              <!-- 詳細住所 -->
              <v-row dense>
                <v-col cols="12" md="9">
                  <validation-provider
                    v-slot="{ errors }"
                    name="詳細住所"
                    rules="max:50"
                  >
                    <v-text-field
                      v-model="emission.address_3"
                      :error-messages="errors"
                      dense
                      label="詳細住所"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      placeholder="例）１−２−３　○○ビル○階"
                    >
                      <template v-slot:label>
                        <span>詳細住所</span>
                        <span class="ml-1">
                          ({{ emission.address_3?.length || 0 }} / 50)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /詳細住所 -->

              <!-- 電話番号 -->
              <v-row dense>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="電話番号"
                    :rules="{ numeric_hyphen_only: true,min: 2, max: 15 }"
                  >
                    <v-text-field
                      v-model="emission.phone_number"
                      :error-messages="errors"
                      dense
                      label="電話番号"
                      hint="電話番号を「-」ハイフン「( )」込みで入力します"
                      persistent-hint
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      placeholder="例）000-0000-0000"
                    >
                      <template v-slot:label>
                        <span>電話番号</span>
                        <span class="ml-1">
                          ({{ emission.phone_number?.length || 0 }} / 15)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="メモ欄"
                    rules="max:30"
                  >
                    <v-text-field
                      v-model="emission.memo"
                      :error-messages="errors"
                      dense
                      label="メモ欄"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      placeholder=""
                    >
                      <template v-slot:label>
                        <span>メモ欄</span>
                        <span class="ml-1">
                          ({{ emission.memo?.length || 0 }} / 30)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /電話番号 -->

            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-checkbox
              v-model="withSelected"
              label="同じ加入者番号の排出事業者のマニフェスト（紐付け未設定）にも紐付けする"
              class="mr-5"
              dense
              persistent-hint
              persistent-placeholder
              style="font-size: 80%"
            />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </validation-observer>
    <confirm ref="confirm" />
    <search-zip-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="emission.prefecture_code"
      :initial-city-name="emission.address_1"
      :initial-town-name="emission.address_2"
      @reflectFullCallback="searchZipReflectCallback"
      @reflectZipCallback="searchZipReflectZipCallback"
      @closeCallback="closeModalCallback"
    />
  </div>
</template>
